import type {SxProps} from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {lighten} from '@mui/system/colorManipulator';
import type {ElementType, FC} from 'react';
import {primaryColor} from '@/theme/theme';

//TYPES
type Props = {
  icon: ElementType;
  value: string;
};

const LabelChipMini: FC<Props> = ({icon: Icon, value}) => {
  return (
    <Stack direction="row" spacing={0.5} sx={styles.chip}>
      <Icon fontSize="small" sx={styles.icon} />
      <Typography variant="overline" sx={styles.label}>
        {value}
      </Typography>
    </Stack>
  );
};

export default LabelChipMini;

const styles: Record<string, SxProps> = {
  chip: {
    alignItems: 'center',
    height: '36px',
    px: 1,
    bgcolor: lighten(primaryColor, 0.95),
    borderRadius: 1,
  },
  icon: {
    color: 'primary.dark',
    bgcolor: lighten(primaryColor, 0.8),
    borderRadius: 1,
    p: 0.25,
    boxSizing: 'content-box',
  },
  label: {
    fontWeight: 'bold',
  },
};
